import './FreelanceSearchIAFilterSidebar.scss'

import {Component} from 'react'
import PropTypes from 'prop-types'
import {Archive, Calendar, Compass, DollarSign, Filter, X} from 'react-feather'

import FilterAvailability from '../../../../../../shared/components/FilterBar/components/FilterAvailability/FilterAvailability.jsx'
import FilterCity from '../../../../../../shared/components/FilterBar/components/FilterCity/FilterCity.jsx'
import FilterDistance from '../../../../../../shared/components/FilterBar/components/FilterDistance/FilterDistance.jsx'
import FilterExperience from '../../../../../../shared/components/FilterBar/components/FilterExperience/FilterExperience.jsx'
import FilterPrices from '../../../../../../shared/components/FilterBar/components/FilterPrices/FilterPrices.jsx'

const COMPLETE_TOPOLOGY_NAME = 'complete'
const PUBLIC_TOPOLOGY_NAME = 'public'

export default class FreelanceSearchIAFilterSidebar extends Component {
  static propTypes = {
    conf: PropTypes.object.isRequired,
    filters: PropTypes.object,
    onValidate: PropTypes.func.isRequired,
    loading: PropTypes.bool,
  }

  static defaultProps = {
    filters: {},
    loading: false,
  }

  constructor(props) {
    super(props)
    this.state = {
      draft: props.filters,
      mobileOpen: false,
    }
  }

  updateDraft = (data) => {
    this.setState((prevState) => {
      const draft = {...prevState.draft, ...data}
      if (Object.prototype.hasOwnProperty.call(data, 'city')) {
        if (data.city) {
          if (draft.distance === undefined || draft.distance === null || draft.distance === '') {
            draft.distance = 40
          }
        } else {
          draft.distance = undefined
        }
      }
      return {draft}
    })
  }

  toggleComplete = () => {
    const {draft} = this.state
    this.updateDraft({[COMPLETE_TOPOLOGY_NAME]: draft[COMPLETE_TOPOLOGY_NAME] ? null : true})
  }

  togglePublic = () => {
    const {draft} = this.state
    this.updateDraft({[PUBLIC_TOPOLOGY_NAME]: draft[PUBLIC_TOPOLOGY_NAME] ? null : true})
  }

  toggleMobile = () => {
    this.setState((prevState) => ({mobileOpen: !prevState.mobileOpen}))
  }

  handleValidate = () => {
    this.props.onValidate(this.state.draft)
    this.setState({mobileOpen: false})
  }

  handleReset = () => {
    this.setState({draft: {}})
    this.props.onValidate({})
  }

  render() {
    const {conf, loading} = this.props
    const {draft, mobileOpen} = this.state

    return (
      <div className="freelance-search-ia-filter-sidebar">
        <button
          type="button"
          className="freelance-search-ia-filter-sidebar__mobile-toggle btn btn-secondary btn-auto-width"
          onClick={this.toggleMobile}
        >
          <Filter size={18} />
          Filtres
        </button>

        {mobileOpen && (
          <div className="freelance-search-ia-filter-sidebar__overlay" onClick={this.toggleMobile} />
        )}

        <div className={`freelance-search-ia-filter-sidebar__inner${mobileOpen ? ' freelance-search-ia-filter-sidebar__inner--open' : ''}`}>
          <div className="freelance-search-ia-filter-sidebar__header">
            <h2>Filtres</h2>

            <button type="button" className="btn-reset" onClick={this.handleReset} disabled={loading}>
              Réinitialiser
            </button>

            <button
              type="button"
              className="freelance-search-ia-filter-sidebar__close btn-auto-width"
              onClick={this.toggleMobile}
            >
              <X size={20} />
            </button>
          </div>

          <div className="freelance-search-ia-filter-sidebar__body">
            <div className="filter-section filter-section--complete d-flex align-items-center justify-content-between">
              <div className="filter-section__title filter-section__title--complete">
                Profil complet
                <span>Fiche vérifiée uniquement</span>
              </div>
              <div className="custom-switch">
                <input
                  id="complete-filter"
                  type="checkbox"
                  className="custom-control-input"
                  checked={!!draft[COMPLETE_TOPOLOGY_NAME]}
                  onChange={this.toggleComplete}
                />
                <label className="custom-control-label" htmlFor={`complete-filter`} />
              </div>
            </div>

            <div className="filter-section filter-section--public d-flex align-items-center justify-content-between">
              <div className="filter-section__title filter-section__title--public">
                Profil public
              </div>
              <div className="custom-switch">
                <input
                  id="public-filter"
                  type="checkbox"
                  className="custom-control-input"
                  checked={!!draft[PUBLIC_TOPOLOGY_NAME]}
                  onChange={this.togglePublic}
                />
                <label className="custom-control-label" htmlFor={`public-filter`} />
              </div>
            </div>

            <div className="filter-section">
              <div className="filter-section__title">
                <Calendar size={22}/>
                Disponibilité
              </div>
              <FilterAvailability
                value={draft.availability}
                onChange={(data) => this.updateDraft({availability: data})}
              />
            </div>

            <div className="filter-section">
              <div className="filter-section__title">
                <Compass size={22}/>
                Localisation
              </div>
                <FilterDistance
                  distance={draft.distance}
                  onChange={(data) => this.updateDraft(data)}
                />
                <FilterCity
                  city={draft.city}
                  relocation={!!draft.relocation}
                  onChange={(data) => this.updateDraft(data)}
                  onChecked={(data) => this.updateDraft({relocation: data ? 1 : 0})}
                  isRemote={true}
                />
            </div>

            <div className="filter-section">
              <div className="filter-section__title">
                <DollarSign size={22}/>
                TJM
              </div>
              <FilterPrices
                priceMin={draft.priceMin}
                priceMax={draft.priceMax}
                onChange={(data) => this.updateDraft(data)}
              />
            </div>

            <div className="filter-section">
              <div className="filter-section__title">
                <Archive size={22}/>
                Expérience
              </div>
              <FilterExperience
                conf={conf}
                experiences={draft.nbYearOfExperience?.length ? draft.nbYearOfExperience : []}
                onChange={(data) => this.updateDraft({nbYearOfExperience: data})}
              />
            </div>
          </div>

          <div className="freelance-search-ia-filter-sidebar__footer">
            <button type="button" className="btn btn-secondary btn-block" onClick={this.handleValidate} disabled={loading}>
              Valider
            </button>
          </div>
        </div>
      </div>
    )
  }
}
